import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { FileSignature, Download, CheckCircle2, Loader2 } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

const COUNTRIES = [['chile', 'Chile'], ['argentina', 'Argentina'], ['mexico', 'México'], ['colombia', 'Colombia'], ['peru', 'Perú'], ['ecuador', 'Ecuador']];
const field = 'w-full px-3 py-2 bg-slate-900/60 border border-slate-700 rounded-lg text-sm';

export const DpaCard = ({ onChange = () => {} }) => {
  const { api } = useAuth();
  const [st, setSt] = useState(null);
  const [f, setF] = useState({ company_name: '', tax_id: '', signer_name: '', signer_role: '', country: 'chile' });
  const [busy, setBusy] = useState(false);
  const load = () => api.get('/security/dpa').then((r) => setSt(r.data)).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const download = async () => {
    const r = await api.get('/security/dpa/pdf', { responseType: 'blob' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(r.data); a.download = 'contrato_tratamiento_datos_notaryos.pdf'; a.click();
  };
  const accept = async () => {
    setBusy(true);
    try { await api.post('/security/dpa/accept', f); toast.success('Contrato aceptado y registrado'); load(); onChange(); }
    catch (e) { toast.error(typeof e.response?.data?.detail === 'string' ? e.response.data.detail : 'Revisa los datos'); }
    finally { setBusy(false); }
  };
  const acc = st?.acceptance;
  const current = acc && acc.version === st.current_version;

  return (
    <div className="space-y-3" data-testid="dpa-card">
      <div className="flex items-center gap-2 font-semibold text-sm"><FileSignature className="w-4 h-4 text-amber-400" /> Contrato de Tratamiento de Datos (DPA)</div>
      {current ? (
        <p className="text-sm text-emerald-300 flex items-center gap-2" data-testid="dpa-accepted-text"><CheckCircle2 className="w-4 h-4" /> Aceptado por {acc.signer_name} ({acc.company_name}) el {new Date(acc.accepted_at).toLocaleDateString('es-CL')} · versión {acc.version}</p>
      ) : (
        <div className="grid sm:grid-cols-2 gap-2">
          <input className={field} placeholder="Razón social del estudio o notaría" value={f.company_name} onChange={(e) => setF({ ...f, company_name: e.target.value })} data-testid="dpa-company-input" />
          <input className={field} placeholder="RUT / RFC / NIT / RUC" value={f.tax_id} onChange={(e) => setF({ ...f, tax_id: e.target.value })} data-testid="dpa-taxid-input" />
          <input className={field} placeholder="Nombre de quien firma" value={f.signer_name} onChange={(e) => setF({ ...f, signer_name: e.target.value })} data-testid="dpa-signer-input" />
          <input className={field} placeholder="Cargo (ej. Socio director)" value={f.signer_role} onChange={(e) => setF({ ...f, signer_role: e.target.value })} data-testid="dpa-role-input" />
          <select className={field} value={f.country} onChange={(e) => setF({ ...f, country: e.target.value })} data-testid="dpa-country-select">
            {COUNTRIES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
          <button onClick={accept} disabled={busy || f.company_name.length < 2 || f.signer_name.length < 3} data-testid="dpa-accept-btn" className="btn-primary py-2 text-sm flex items-center justify-center gap-2 disabled:opacity-50">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />} Aceptar contrato
          </button>
        </div>
      )}
      <button onClick={download} data-testid="dpa-download-btn" className="text-sm px-3 py-2 rounded-lg border border-slate-700 hover:bg-slate-800 flex items-center gap-2"><Download className="w-4 h-4" /> Descargar PDF{current ? ' firmado' : ' (borrador)'}</button>
    </div>
  );
};
